import { put, call, takeEvery } from "redux-saga/effects"
import { authRequest } from "src/engine/modules/authRequest"
import env from "src/env"
import { REQUESTED_API_ENTITY_LIST } from "../actions/types"

import {
  requestApiEntityListSuccess,
  requestApiEntityListError,
} from "../actions/creators"

const { REACT_APP_API_URL } = env

function* request(action) {
  const {
    config: { name, urlName },
  } = action
  try {
    const response = yield call(authRequest, {
      url: `${REACT_APP_API_URL}${urlName || name}`,
      method: `get`,
    })
    yield put(requestApiEntityListSuccess(action, response))
  } catch (error) {
    yield put(requestApiEntityListError(action, error))
  }
}

export default function* requestSaga() {
  yield takeEvery(REQUESTED_API_ENTITY_LIST, request)
}
